/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/mrz/MRZScannerUIResult.yaml
import { GenericDocument } from '../../documents/GenericDocument';
import { ToJsonConfiguration } from '../../utils/json/JsonSerializationTypes';
import { PartiallyConstructible } from '../../utils/utils';
/**
Configuration of the MRZ RTU UI result.
*/
export class MrzScannerUiResult extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<MrzScannerUiResult>`} */
    constructor(source = {}) {
        super();
        this._released = false;
        if (source.rawMRZ !== undefined) {
            this.rawMRZ = source.rawMRZ;
        }
        else {
            throw new Error('rawMRZ must be present in constructor argument');
        }
        if (source.mrzDocument !== undefined) {
            this.mrzDocument = source.mrzDocument != null ? new GenericDocument(source.mrzDocument) : null;
        }
        else {
            throw new Error('mrzDocument must be present in constructor argument');
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            rawMRZ: this.rawMRZ,
            mrzDocument: this.mrzDocument != null ? await this.mrzDocument.serialize(config) : null,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.mrzDocument != null) {
                this.mrzDocument.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.mrzDocument != null) {
            await this.mrzDocument.encodeImages();
        }
    }
}
//# sourceMappingURL=MRZScannerUIResult.js.map